import { render, staticRenderFns } from "./EventPreset.vue?vue&type=template&id=afd63d22&"
import script from "./EventPreset.vue?vue&type=script&lang=js&"
export * from "./EventPreset.vue?vue&type=script&lang=js&"
import style0 from "./EventPreset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventPreset.vue"
export default component.exports